import {Component, inject, OnInit} from '@angular/core';
import {CommonModule, Location} from '@angular/common';
import {ActivatedRoute} from "@angular/router";
import {
    DxButtonModule,
    DxDateBoxModule,
    DxLoadPanelModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxScrollViewModule,
    DxNumberBoxModule
} from "devextreme-angular";
import {
    StorageType,
    InventoryClient,
    MaterialDto,
    MaterialStatus,
    UpdateMaterialCommand
} from '@services';
import notify from "devextreme/ui/notify";
import EnumUtils from "../../../../shared/enum-utils";
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";

@Component({
  selector: 'app-material-details',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxNumberBoxModule,
        CapitalCasePipe
    ],
  templateUrl: './material-details.component.html',
  styleUrl: './material-details.component.scss',
})
export class MaterialDetailsComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private location = inject(Location);
    private inventoryClient = inject(InventoryClient);

    protected materialNumber: string | null = null;
    protected material: MaterialDto = new MaterialDto();
    protected isLoading = false;
    protected storageTypeOptions = EnumUtils.getEnumOptions(StorageType);

    protected getStatusBadgeClass(status: MaterialStatus): string {
        return EnumUtils.getMaterialStatusBadgeClass(status);
    }

    ngOnInit(): void {
        this.materialNumber = this.route.snapshot.paramMap.get('number');
        if (this.materialNumber) {
            this.loadMaterial();
        } else {
            notify('Material Number missing', 'error', 3000);
            this.cancel();
        }
    }

    private loadMaterial() {
        this.isLoading = true;
        this.inventoryClient.getMaterial(this.materialNumber!).subscribe({
            next: (data) => {
                this.material = data;
                this.isLoading = false;
            },
            error: () => {
                notify('Failed to load material', 'error', 3000);
                this.isLoading = false;
                this.location.back();
            }
        });
    }

    save() {
        const command = new UpdateMaterialCommand({
            number: this.materialNumber!,
            actualStorageType: this.material.actualStorageType
        });

        this.inventoryClient.updateMaterial(command).subscribe({
            next: () => {
                notify('Material updated successfully', 'success', 3000);
            },
            error: () => {
                notify('Failed to update material', 'error', 3000);
            }
        });
    }

    cancel() {
        this.location.back();
    }
}
